export enum ProfileMenu {
  PROFILE = 0,
  REPORT = 1,
  CONTACT = 2,
  LOG_OUT = 3,
}
